import styled from 'styled-components';

import {
  Colors,
  Sizes,
} from '@noitada/shared/constants';

import {
  ListFlat,
} from '../../components/Composh/web';



export const PaymentModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  background-color: ${Colors.cardBackground};
  border-radius: ${Sizes.cardRadius}px;

  min-width: 320px;
  max-width: 360px;
  max-height: 500px;
`;


export const PaymentPadderHorizontal = styled(ListFlat).attrs({
  contentContainerStyle: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 10,
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 10,
  },
})`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
